$(function(){
  $(".videolink").fancybox({
    maxWidth    : 800,
    maxHeight   : 400,
    fitToView   : false,
    width       : '90%',
    height      : 400,
    autoSize    : false,
    closeClick  : false,
    openEffect  : 'elastic',
    closeEffect : 'none'
  });

  var cookieAccepted = readCookie("cookieAccepted");
  if(!cookieAccepted){
    $(".pop-up-confidentialite").addClass("popped");
  }

  $(".btn-politique").on("click",function(){
    createCookie("cookieAccepted", true, 365);
    location.reload();
  });

  /*
  ====================
  == HEADER FIXED CHANGE ON SCROLL ==
  ====================
  */
  var headerHeight = $("#main-header").height();
  var scrollHeight = 192;
  var windowWidth = $(window).width();

  $(window).on('resize', function(){
    headerHeight = $("#main-header").height();
    $("#page").css("padding-top",headerHeight);
    windowWidth = $(window).width();
    headerFixed();
  });

  function headerFixed(){
    if (windowWidth >= 1025){
      if ($(window).scrollTop() > (scrollHeight)){
        $("#main-header").addClass("fixed");
        $("#page").css('padding-top',headerHeight);
      }
      else{
        $("#page").css('padding-top',headerHeight);
        $("#main-header").removeClass("fixed");
      }

      $(window).on('scroll',function () {
        if ($(window).scrollTop() > (scrollHeight)){
          $("#main-header").addClass("fixed");
          $("#page").css('padding-top',headerHeight);
        }
        else{
          $("#main-header").removeClass("fixed");
          $("#page").css('padding-top',headerHeight);
        }
      });
    }
    else{
      $("#page").css('padding-top',headerHeight);
      $("#main-header").removeClass("fixed");
    }
  }

  // init
  headerFixed();

  window.Parsley.setLocale($('html').attr('lang'));

  if ($('img.unveil').length > 0) {
    $('img.unveil').unveil(250);
  }

  if ($('img.unveil-bg').length > 0){
    $("img.unveil-bg").unveil(250, function() {
      $(this).backgroundCover();
    });
  }

  if ($('form.parsley').length > 0){
    $('form.parsley').parsley({});
  }

  $("a.fancy-box").fancybox();

 function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name,"",-1);
  }



  /*
  ===============
  ==Mobile Menu==
  ===============
  */
  $("a.menu.mobile").on("click",function(){
    $(this).toggleClass("active");
    $(".mobile-overlay").fadeToggle( "slow", "linear" );
    $("#main-content,#main-footer,header#main-header nav#main-nav .nav ,body").toggleClass("active");
  });

  $(".has-sub .angle-cont").on("click",function(){
    $(this).parent().toggleClass("active");
  });
  $(".open-sub").on("click",function(){
    $(this).parent().toggleClass("active");
  });

  /*
  ==========================
  ==Smooth Scroll function==
  ==========================
  */
  $(function() {
    $('a[href*="#"]:not([href="#"])').on("click",function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });

  /*
  ====================
  ==Open a modal box==
  ====================
  */
  var myModal = "";
  $(".modal-trigger").on("click",function(){
    myModal = $(this).attr("href");
    $(myModal).fadeIn("slow");
    $(".modal-overlay").fadeIn("slow");
  });
  $(".modal-footer .btn").on("click",function(){
    $(myModal).fadeOut("slow");
    $(".modal-overlay").fadeOut("slow");
  });

  /*
  =====================
  ==O B J E C T I F S==
  =====================
  */
  $(".goal-phone").on("click",function(){
    googleAnalytic('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'click',
      eventLabel: 'click-telephone',
      eventValue: 1
    });
    facebookTag('track', 'Contact', { content_type: 'telephone' });
  });

  if($(".goal-message-success").length){
    googleAnalytic('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'sent',
      eventLabel: 'sent-contact-form',
      eventValue: 1
    });
  }
});


/*
==========================================
==Recalling bg-cover to prevent glitches==
==========================================
*/
$(window).resize(function(){
  $(".bg-cover").backgroundCover();
});

$(window).on('load',function() {
  $(".bg-cover").backgroundCover();
});

$(document).ready(function(){

  $(".bg-cover").backgroundCover();

  window.onfocus = function () {
    $(".bg-cover").backgroundCover();
  };

  window.onblur = function () {
    $(".bg-cover").backgroundCover();
  };
});
